import React, { useState } from "react";
import "./userList.css";
import { userRows } from "../../data/fakeUserRow";
import { Link } from "react-router-dom";
import { DeleteOutline } from "@material-ui/icons";
import { DataGrid } from "@material-ui/data-grid";
const UserList = () => {
  const [data, setdata] = useState(userRows);

  function onDelUser(id) {
    setdata(data.filter((item) => item.id !== id));
  }

  const columns = [
    { field: "id", heaferName: "ID", width: 90 },
    {
      field: "user",
      headerName: "User",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="user_list_uset">
            <img src={params.row.avatar} alt="" className="user_list_img" />
            {params.row.username}
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
    },
    {
      field: "transaction",
      headerName: "Transaction Volume",
      width: 160,
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <React.Fragment>
            <Link to={`/user/${params.row.id}`}>
              <button className="user_list_edit">Edit</button>
            </Link>
            <DeleteOutline
              className="user_list_delete"
              onClick={() => onDelUser(params.row.id)}
            />
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <div className="user_list">
      <DataGrid
        rows={data}
        disableSelectionOnClick
        columns={columns}
        pageSize={8}
        checkboxSelection
      />
    </div>
  );
};

export default UserList;
